import { css } from "lit";
import { Style } from "../Styles";

export const styles = css`
    ${Style}
    :host {
        display: block;
        --max-width: 1024px;
    }

    .container {
        flex-direction: column;
        width: 100%;
        max-height: 100%;
        height: 100%;
        max-width: var(--max-width);
        margin-left: auto;
        margin-right: auto;
        border-radius: 1em 1em 0px 0px;
        display: grid;
        grid-template: "header" auto "main" 1fr "footer" auto / 1fr;
        background-color: white;
    }

    .view-container {
        padding: 0;
    }

    .scrolling-container {
        overflow-y: auto;
        grid-area: main;
    }

    .header {
        position: relative;
        height: 312px;
        min-height: 312px;
        color: white;
    }

    .banner {
        position: relative;
        height: 100%;
    }

    /* Add a gradient over the banner image */
    .banner-image:after {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        display: inline-block;
        background: linear-gradient(rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.8) 90%);
    }

    .banner-footer {
        position: absolute;
        width: 100%;
        height: 4em;
        bottom: 0;
        background-color: var(--place-view-banner-splash-color);
        opacity: 0.6;
    }

    ds-close-button {
        position: absolute;
        top: 2em;
        right: 2em;
    }

    .header ds-media {
        width: 100%;
        height: 100%;
    }

    .header ds-media::part(image) {
        object-fit: cover;
        border-radius: 1em 1em 0 0;
    }

    .header .info {
        position: absolute;
        top: 0.5em;
        left: 1em;
        right: 1em;
        display: flex;
        flex-direction: column;
        gap: 0em;
    }

    .info h1 {
        margin-bottom: 0em;
        margin-top: 0;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        width: 100%;
        box-sizing: content-box;
    }

    .header .buttons {
        position: absolute;
        bottom: 1em;
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
        width: 100%;
    }

    .header .header-button {
        align-items: center;
    }

    .header .header-button sl-icon-button {
        font-size: 1.5em;
        color: black;
        background-color: white;
        border-radius: 50%;
        padding: 0.3em;
    }

    .body {
        padding: 0.5em;
        background-color: white;
    }

    .footer {
        grid-area: footer;
        padding: 1em;
    }

    .content {
        flex: 65%;
        color: black;
        border-right: grey solid 1px;
        padding: 0.5em;
    }

    .sidebar {
        flex: 35%;
        padding: 1em;
        color: black;
    }

    ds-fixed-panel {
        overflow-y: auto;
    }

    .panel-footer {
        display: flex;
        padding: 1em;
        justify-content: flex-end;
        gap: 1em;
    }

    .two-column-list {
        list-style-type: none;
        columns: auto 2;
        -webkit-columns: 2;
        -moz-columns: 2;
        padding-left: 0;
    }

    @media only screen and (max-width: 640px) {
        .two-column-list {
            columns: auto 1;
            -webkit-columns: 1;
            -moz-columns: 1;
        }
    }

    .three-column-list {
        list-style-type: none;
        columns: auto 3;
        -webkit-columns: 3;
        -moz-columns: 3;
        padding-left: 0;
    }

    @media only screen and (max-width: 640px) {
        .three-column-list {
            columns: auto 2;
            -webkit-columns: 2;
            -moz-columns: 2;
        }
    }

    .command-item {
        display: flex;
        flex-direction: row;
    }

    .command-button {
        display: block;
        flex: 1;
    }
    .command-button sl-icon {
        margin-right: 0.5em;
    }

    .command-button::part(base) {
        justify-content: left;
        background-color: transparent;
        border-color: transparent;
        font-weight: unset;
        font-size: 1.1em;
    }

    .command-button a {
        text-decoration: unset;
        font-weight: unset;
        color: black;
    }

    .edit-button {
        font-size: 1.8em;
    }

    .description-text {
        color: black;
    }

    .banner-no-image {
        width: 100%;
        height: 100%;
        background-color: var(--place-view-banner-splash-color);
    }

    .command-buttons {
        display: block;
    }

    ds-places-map {
        height: 30em;
        overflow-y: clip;
        border-radius: 0.5em;
    }
    ds-media-carousel {
        height: auto;
        border-radius: 0.5em;
        cursor: pointer;
    }

    ds-media-editor {
        width: 100%;
    }

    article h1,
    article h2,
    article h3,
    article h4,
    article span,
    article p {
        color: black;
        margin-top: 0.5em;
    }

    h3 {
        margin-top: 0.5em;
        margin-bottom: 0.2em;
    }

    ds-place-editor {
        flex: 1;
    }

    .editor-container {
        width: 100%;
        height: 100%;

        min-height: 100%;
        padding: 0rem;
        display: flex;
        flex-direction: column;
    }

    .editor-footer {
        display: flex;
        flex-direction: column;
    }

    sl-icon-button {
        color: black;
    }

    ds-place-report-editor {
        width: 100%;
    }

    ds-place-report {
        width: 100%;
        padding-right: 1em;
    }

    .amenity i {
        min-width: 1.5em;
    }

    .command-buttons sl-icon {
        padding-right: 0.5em;
    }

    .disclaimer {
        background-color: darkorange;
        padding: 0.5em;
        border-radius: 0.5em;
    }

    .disclaimer span {
        color: white;
    }

    .section-header {
        width: 100%;
        padding-top: 1em;
        border-bottom: lightgray solid 1px;
        padding-bottom: 0.3em;
    }

    .bookmark-button {
        position: absolute;
        right: 0.5em;
        bottom: 0.125em;
        color: gold;
        font-size: 2em;
    }

    @media only screen and (max-width: 600px) {
        .body {
            flex-direction: column;
        }

        .content {
            border-right: none;
        }

        ds-media-carousel {
            height: 30em;
        }
    }
`;
